import "../../shared/styles/urbanist.css";
import "../../shared/styles/roboto.css";
import "../../shared/styles/app.css";
import App from "./MyPagesRoot.svelte";

const app = new App({
  target: document.getElementById("app")!,
});

export default app;
